import axios from "axios";
import { store } from "redux/store";
import { logoutAndClearSession } from "redux/auth/logoutAndClearSession";
import { getApiUrl } from "util/apiUrl";

const Api = axios.create({ baseURL: getApiUrl() });

Api.interceptors.request.use(
  async config => {
    if (localStorage.getItem("isLogin") === "true") {
      config.headers = {
        ...config.headers,
        "access-token": localStorage.getItem("Authorization")
      };
    }
    return config;
  },
  error => {
    Promise.reject(error);
  }
);

Api.interceptors.response.use(
  response => {
    return response;
  },
  error => {
    const status = error.response ? error.response.status : null;
    if (status === 401) {
      store.dispatch(logoutAndClearSession());
    }
    return Promise.reject(error);
  }
);

export default Api;
